import { useState } from 'react';
import Menu from '../../../../components/Menu/Menu';
import './PartyFun.scss';
import Button from '../../../../components/Button/Button';



function TeamContainer({ color, children, team, setTeam }) {
    return (
        <div className={`team-container background-${color}`}>
            <Button onClick={() => {
                const playerName = prompt(`Enter the name of the player to add to ${color} team:`, '');
                if (playerName && playerName.trim() !== '') {
                    setTeam([...team, playerName.trim()]);
                }
            }}>
                Add Player to {color.charAt(0).toUpperCase() + color.slice(1)} Team
            </Button>
            <div className="players-list">
                <h4>{color.charAt(0).toUpperCase() + color.slice(1)} Team Players:</h4>
                {team.length === 0 && <p>No players added yet.</p>}
                <ul>
                    {team.map((player, index) => (
                        <li key={index}>{player}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default function TeamSelector({ team1, team2, setTeam1, setTeam2 }) {

    return (
        <div id='team-selector'>
            <div className="centered-container">
                <div className="containers-wrapper">
                    <TeamContainer color="red" team={team1} setTeam={setTeam1} />
                    <TeamContainer color="blue" team={team2} setTeam={setTeam2} />
                </div>
                <Menu title="" options={[
                    { name: 'Go Back', path: '/..' },
                ]} />
            </div>
        </div>

    );
}